// extracted by mini-css-extract-plugin
export default {"container":"skip-links_container__fIFD2","link":"skip-links_link__SFDWi"};